export const SUMMARIZATION_MODELS = {
  mbart: "mBART",
  transformer: "Transformer",
  bloomz: "BLOOMZ",
  mt5: "mT5",
  mt0: "mT0",
  gpt2_nepali: "GPT2 Nepali",
  gpt2_nepali_instruct: "GPT2 Nepali Instruct",
} as const

export const summarizationConfig = {
  id: "summarize",
  title: "Summarization",
  endpoint: import.meta.env.VITE_API_ENDPOINT,
  available_models: SUMMARIZATION_MODELS,
  input_text_min_length: 10,
} as const